// Whole days between today and the given timestamp, both taken at local midnight.
export const getDaysAmount = (timestamps: number) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const date = new Date(timestamps)
  date.setHours(0, 0, 0, 0)
  const diffTime = date.getTime() - today.getTime()
  return Math.floor(diffTime / (1000 * 60 * 60 * 24))
}
